;(function () {
  'use strict'

  angular
    .module('contrast.settings.user.tsv')
    .factory(
      'userTsvService',
      function userTsvServiceFactory($uibModal, $translate) {
        var modalBackupTemplate =
          'components-org/user-tsv/modal_backup_codes.html'

        return {
          showScratchCodeModal: function showScratchCodeModal(backupCodes) {
            return $uibModal.open({
              templateUrl: modalBackupTemplate,
              controller: 'ModalTsvBackupCodesCtrl',
              controllerAs: 'modalTsvBackupCodesCtrl',
              size: 'md',
              resolve: {
                title: function () {
                  return $translate.instant('title_backupCodes')
                },
                codes: function () {
                  return backupCodes
                }
              }
            })
          }
        }
      }
    )
})()
